import { useQuery } from 'react-query';
import { queryKeys } from './queryKeys';
import { useRouteParams } from '../hooks/useRouteParams';
import { authFetch } from '../../CommonUtils/authFetch';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { DepositFrequencyType } from '../../ApexOPL/TransferMoney/api/useAchFundingOptionsQuery';

export interface ScheduledTransferDTO {
  scheduledTransferId: string;
  fundingFrequency: DepositFrequencyType;
  fundingFrequencyDescription: string;
  amount: number;
  submittedOn: Date;
  firstDepositDate: Date;
  secondDepositDate: Date;
  accountName: string;
  institutionName: string;
}

interface FetchScheduledTransfersParams {
  clientId: string;
  managedAccountId: string;
}

const fetchScheduledTransfers = ({
  clientId,
  managedAccountId,
}: FetchScheduledTransfersParams): Promise<ScheduledTransferDTO[]> =>
  authFetch(urlWithParams('/Consumer/AchScheduledTransfers', { clientId, managedAccountId }));

export const useScheduledTransfersQuery = (managedAccountId: string) => {
  const { clientId } = useRouteParams();

  return useQuery(queryKeys.scheduledTransfers({ clientId, managedAccountId }), () =>
    fetchScheduledTransfers({ clientId, managedAccountId }),
  );
};
